/**
 * KNK-1.7 — Offices and field profiles.
 *
 * ⚠️ THIS MODULE HOLDS NO RULES. What the answers mean is `lib/fieldProfiles.ts`; who may change
 * what is the database's (migration 20261009a1). Errors are thrown with the server's own message,
 * because every refusal there is a sentence written for the person reading it.
 */

import { supabase } from '@/lib/supabaseClient';
import { parseFieldProfile, parseFieldProfiles, parseOfficeTeams, type FieldProfile, type OfficeTeam } from '@/lib/fieldProfiles';

/** field.settings.manage. Everyone in the account; never their home address. */
export async function fetchFieldProfiles(): Promise<FieldProfile[]> {
  const { data, error } = await supabase.rpc('field_rep_profiles_list');
  if (error) throw new Error(error.message);
  return parseFieldProfiles(data);
}

/** Send only the keys that changed (`adminPayload`). Returns the profile as the server now has it. */
export async function saveFieldProfile(userId: string, profile: Record<string, unknown>): Promise<FieldProfile> {
  const { data, error } = await supabase.rpc('save_field_rep_profile', { p_user: userId, p_profile: profile });
  if (error) throw new Error(error.message);
  const saved = parseFieldProfile(data);
  if (!saved) throw new Error('The profile came back in a shape this screen does not understand.');
  return saved;
}

/** The account's teams, Offices among them (teams RLS keeps it to the active account). */
export async function fetchOfficeTeams(): Promise<OfficeTeam[]> {
  const { data, error } = await supabase.from('teams').select('id, name, is_office, timezone, office_id').order('name');
  if (error) throw new Error(error.message);
  return parseOfficeTeams(data);
}

export async function setTeamOffice(teamId: number, isOffice: boolean, timezone: string | null): Promise<void> {
  const { error } = await supabase.rpc('set_team_office', { p_team_id: teamId, p_is_office: isOffice, p_timezone: timezone });
  if (error) throw new Error(error.message);
}

export async function setTeamOfficeParent(teamId: number, officeId: number | null): Promise<void> {
  const { error } = await supabase.rpc('set_team_office_parent', { p_team_id: teamId, p_office_id: officeId });
  if (error) throw new Error(error.message);
}
